<!-- Wrapper Body -->
<div class="wrapper-body" *ngIf="show">
  <div class="align-items-md-center d-flex flex-column flex-md-row page-header">
    <h3>{{title}}</h3>
    <!-- <a routerLink="../create-appointment" class="ml-md-auto theme-button" *ngIf='userRole=="ADMIN"'>Create Appointment</a> -->
  </div>
  <div class="content" *ngIf='appointments.length>0'>
    <table id="upcomingAppoitmentTable" class="d-block">
      <tbody class="d-block">
        <tr class="d-flex flex-wrap" *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR")'>

          <!-- Loop this td -->
          <td class="d-block" *ngFor="let appointment of appointments">
            <div class="card">
              <a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]"
                class="position-absolute w-100 h-100"></a>
              <div class="date-time bg-theme-light">
                <span class="text-grey">{{appointment.appointmentDetails.schedules[0].appointmentDate}}</span>
                <span class="float-right text-purple">{{appointment.appointmentDetails.schedules[0].appointmentTime}}</span>
              </div>
              <div class="client-diagno d-flex align-items-center justify-content-between">
                <p class="text-purple mb-0">{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</p>
                <div class="connector bg-green"></div>
                <p class="text-right text-green mb-0">
                  <span class="d-block text-grey"><small>Diagnostician</small></span>
                  {{appointment.appointmentDetails.diagnosticianName}}
                </p>
              </div>
              <hr>
              <div class="test-location">
                <p class="float-md-left mb-3"><img src="assets/images/icons/test.svg" class="mr-2"
                    width="13">{{appointment.appointmentDetails.assesmentType}}</p>
                <p class="float-md-right"><img src="assets/images/icons/location.svg" class="mr-2"
                    width="13">{{appointment.appointmentDetails.location}}</p>
              </div>
              <div class="client-detail">{{appointment.parentDetails.cellNumber}} {{appointment.parentDetails.emailAddress}}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>


    <!-- Diagnostician Upcoming Card -->
    <div class="diagno-upcoming-card"  *ngIf='this.userRole=="DIAGNOSTIC"'>
      <div class="row">
        <div class="col-lg-6" *ngFor="let appointment of appointments">
          <div class="card">
            <div class="outer">
              <div class="d-flex mb-3 align-items-center">
                <div class="time bg-theme-light rounded mr-3 py-2 px-3">
                  <p class="text-grey mb-1"><small>{{appointment.appointmentDetails.schedules[0].appointmentDate}}</small></p>
                  <p class="mb-0 float-right text-purple"><b>{{appointment.appointmentDetails.schedules[0].appointmentTime}}</b></p>
                </div>
                <div class="client flex-fill">
                  <p class="text-green mb-1"><b>{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</b></p>
                  <p class="float-md-left mb-0">{{appointment.appointmentDetails.assesmentType}}</p>
                </div>
              </div>
              <div class="actions d-flex">
                <a [routerLink]="['/appt-all-details',appointment.appointmentDetails.appointmentId]"
                  class="theme-button green mr-2 flex-fill px-2 py-2 justify-content-center">View Details</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="appointments.length<1">
    <div class="row">
      <div class="col-12">
        <div class="card py-5 px-2 text-center">
          <h4 class="text-grey">No Appointments</h4>
          <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
        </div>
      </div>
    </div>
  </div>




</div>
<div>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
    <!-- <p style="color: white">Please Wait... </p> -->
  </ngx-spinner>
</div>